import {
  employeesSearchSchema,
  employeesViewColumns,
  mapEmployeesViewQuery,
} from "./EmployeesView.default";
import ManagedGridView from "../controls/ManagedGridView";
import { SearchQuery } from "../code/search-query/search-query";
import { getCompanyEmployees } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface EmployeesViewProps {
  readonly trigger?: string;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
  readonly onAction?: (key: string, record: any) => void;
}

function EmployeesView(props: EmployeesViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={employeesViewColumns}
      schema={employeesSearchSchema}
      mapQuery={mapEmployeesViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getCompanyEmployees)}
      actions={[
        {
          key: "view",
          label: "View",
          disabled: !permissions.can("CompanyEmployees", "view"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("CompanyEmployees", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default EmployeesView;
